<template>
  <el-pagination
    ref="pagination"
    :background="showBackground"
    :layout="pageData.total > pageData.per_page ? 'prev, pager, jumper, next, total' : 'total'"
    :hide-on-single-page="hideOnSinglePage"
    :pager-count="pageCount"
    :total="pageData.total"
    :page-size="pageData.per_page"
    :current-page="pageData.current_page"
    :page-count="pageData.last_page"
    @prev-click="$emit('change-page', pageData.current_page - 1)"
    @next-click="$emit('change-page', pageData.current_page + 1)"
    @current-change="onChangePage" />
</template>

<script>
export default {
  name: 'xolas-table-pagination',

  props: {
    pageData: {
      type: Object,
      required: true,
      validator: (v) => typeof v.total === 'number' && typeof v.current_page === 'number'
    },
    showBackground: {
      type: Boolean,
      default: false
    },
    hideOnSinglePage: {
      type: Boolean,
      default: true
    },
    pageCount: {
      type: Number,
      default: 5
    }
  },

  methods: {
    onChangePage (page) {
      this.$emit('change-page', page)
    }
  }
}
</script>
